export default "__VITE_ASSET__Caw9vfV2__"